<template>
  <div class="quickly scroll_bar">
    <div class="quicklytag ">
      <span v-for="(item, index) of list" :key="index" v-if="(item.menuType === 1 && userInfo.status !== 2)||item.menuType !== 1 ">
        <div @click="choose(item)">
          <i :class="item.menuType == 1 ? 'el-icon-user' : item.menuType == 0 ? 'el-icon-question' : item.menuType == 6 ? 'el-icon-copy-document' : item.menuType == 3 ? 'el-icon-circle-close' : item.menuType == 5 ? 'el-icon-message' : 'el-icon-star-off'"></i>
          {{ item.menuName }}
        </div>
      </span>
    </div>
  </div>
</template>

<script>

import urlParams from "../../api/urlParams";
import chatApi from "../methods";
import store from "../../store";
export default {
  name: "side",
  data() {
    return {
      sideShow: true,
      list: [],

      isIframe: false,
    }
  },
  watch: {
    initData() {

      return this.$store.state.initData;
    },
    connectStatus() {
      if (this.$store.state.connectStatus == 'manual') {
        this.list = this.list.filter((item) => {
          return item.menuType !== 1;
        });
      }

      return this.$store.state.connectStatus
    }
  },
  computed: {
    initData() {
      if (this.$store.state.initData.chatMenuConfigPlan) {
        this.list = this.$store.state.initData.chatMenuConfigPlan.chatMenuConfigList || [];
      }
        if (this.$store.state.initData.evaluateMode) {
            this.list = this.list.filter((item) => {
                return item.menuType !== 4;
            });
            this.list.unshift({
                menuType: 4,
                menuName: this.$t("evaluate")
            })
        }
        if (this.$store.state.initData.leaveMsgMode) {
            this.list = this.list.filter((item) => {
                return item.menuType !== 5;
            });
            this.list.unshift({
                menuType: 5,
                menuName: this.$t("leaveMsg")
            })
        }
        if (this.$store.state.initData.transferUserMode) {
        this.list = this.list.filter((item) => {
          return item.menuType !== 1;
        });
        this.list.unshift({
            menuType: 1,
            menuName: this.$t("transform")
          })
      }
      return this.$store.state.initData;
    },
    customer() {
      return this.$store.state.customer;
    },
    connectStatus() {
      return this.$store.state.connectStatus
    },
      userInfo() {
          return this.$store.state.userInfo;
      },
  },
  mounted() {
    if (urlParams("from") === "iframe") {
            this.isIframe = true;
        }
  },
  methods: {
    choose(item) {
      if (item.menuType == 0) {
        const obj = {
          docId: item.docId,
          click: 1,
          msgContent: item.msgText,
          senderType: 1, // 发送人 1用户，2客服，3机器人
          date: new Date().getTime(),
          msgType: 1, // 消息类型 1文本
          status: "loading", // 消息状态 成功后隐藏否则一直loading
          id: "message" + new Date().getTime(),
        };
        // 更新聊天消息
        this.$store.dispatch("setChatList", obj);
        chatApi.sendMessage(obj);
      } else if (item.menuType == 6) {
        window.open(item.labelLink, "_blank");
      } else if (item.menuType == 3) {
        chatApi.closeChatSession();
      } else if (item.menuType == 4) {
        if (this.$store.state.enableEvaluate) {
          chatApi.getEvaluateMsg(() => {
            this.$store.dispatch("setConfigPc", [
              { key: "showModal", value: true },
              {
                key: "evaluateModal",
                value: true,
              },
            ]);
          });
        } else {
          let obj = {
            senderType: 4, // 消息类型 1文本
            msgContent: this.$t("chatAfterEva"),
          };
          this.$store.dispatch("setChatList", obj);
          this.$store.dispatch("setScrollBottom");
        }
      } else if (item.menuType == 1) {

        chatApi.chatForm();
      } else {
        // this.$store.dispatch("setConfigPc", [
        //   { key: "showModal", value: true },
        //   { key: "messageModal", value: true },
        // ]);
        if (this.isIframe) {
        this.$router.push(
          "/leaveMessage" +
          "?channelId=" +
          this.$route.query.channelId +
          "&tenantId=" +
          store.state.initData.tenantId +
          "&userId=" +
          store.state.userInfo.userId +
          "&from=iframe"
        );
      } else {
        this.$router.push(
          "/leaveMsg" +
          "?channelId=" +
          this.$route.query.channelId +
          "&tenantId=" +
          store.state.initData.tenantId +
          "&userId=" +
          store.state.userInfo.userId
        );
      }
      }
    }
  }
}
</script>

<style scoped>
.quickly {
  width: 100%;
  height: 50px;
  padding-left: 10px;
  box-sizing: border-box;
  background-color: #fff;
  overflow-y: hidden;
  overflow-x: scroll;
  display: flex;
  touch-action: pan-x;
  scrollbar-width: none;
  /*Firefox*/
  -ms-overflow-style: none;
    border-bottom: 0.1px solid #dddddd;
  /*IE10+*/
}


.quickly::-webkit-scrollbar {
  /*height: 1px;*/
  /*width: 1px;*/
   display: none;
}

.quicklytag {
  display: inline-flex;
  white-space: nowrap;
  touch-action: pan-x;
}

.quickly span {
  height: 30px;
  background: #FFFFFF;
  border-radius: 16px;
  border: 1px solid #E0E0E0;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 400;
  color: #161616;
  cursor: pointer;
  display: inline-block;
  box-sizing: border-box;
  margin-right: 10px;
  margin-right: 10px;
  float: left;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/quicklty.vue